import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  loginFormWrapper: {
    padding: theme.spacing(52.5, 62.5),
    maxWidth: theme.spacing(175),
    boxSizing: 'content-box',
    '& h1': {
      maxWidth: theme.spacing(150),
    },
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(60, 40, 20),
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '70%',
    },
    [theme.breakpoints.down('xs')]: {
      boxSizing: 'border-box',
      padding: theme.spacing(25, 17, 17),
      maxWidth: 'unset',
      '& h1': {
        maxWidth: theme.spacing(120),
      },
    },
  },
  arrow: {
    marginLeft: theme.spacing(4),
    marginTop: 24,
    border: `solid ${theme.palette.primary.main}`,
    borderWidth: '0 3px 3px 0',
    padding: '4px',
    display: 'block',
    transform: 'rotate(135deg)',
    cursor: 'pointer',
    width: 6,
    height: 6,
  },
  passwordInputWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 2,
    alignItems: 'center',
  },
  loginFormContent: {
    padding: theme.spacing(29, 0, 30),
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(26, 0),
    },
  },
  verifyCodeFormContent: {
    '& > div > div': {
      marginBottom: 4,
    },
  },
  loginButtonWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    paddingBottom: theme.spacing(29),
    '& > i': {
      margin: 0,
    },
    [theme.breakpoints.down('xs')]: {
      paddingBottom: theme.spacing(12),
    },
  },
  emailInputField: {
    marginBottom: theme.spacing(14.5),
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(6),
    },
  },
  loginBtn: {
    '& span': {
      textTransform: 'capitalize',
      font: 'normal normal bold 16px/18px Roboto',
      '& > i': {
        display: 'inline-block',
      },
    },

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(7.5),
    },
  },
  resetCode: {
    fontSize: theme.spacing(6.5),
    lineHeight: '14px',
    marginTop: theme.spacing(1.5),
  },
  resetCodeLink: {
    color: '#474DDC',
    textDecoration: 'none',
  },
  forgotPassword: {
    fontSize: theme.spacing(6.5),
    lineHeight: '14px',
    letterSpacing: 0,
    color: '#474DDC',
    marginLeft: 24,
    marginTop: theme.spacing(3.5),
    textDecoration: 'none',

    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(5.5),
    },
  },
  loginBtnLabel: {
    [theme.breakpoints.down('sm')]: {
      '& span': {
        fontSize: theme.spacing(7.5),
        lineHeight: '22px',
        fontWeight: 500,
      },
    },
  },
  textNearToSignupLink: {
    fontSize: theme.spacing(7),
    lineHeight: '18px',
    letterSpacing: 0,
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
    [theme.breakpoints.down('sm')]: { fontSize: theme.spacing(5.5), lineHeight: '14px' },
  },
  signupLink: {
    color: '#474DDC',
    textDecoration: 'none',
  },
}));
